"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSwitcher = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["id", "children", "className"];
var FormSwitcher = exports.FormSwitcher = function FormSwitcher(_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var elementClasses = (0, _classnames["default"])('form-switcher', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: elementClasses
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    id: id,
    type: "checkbox",
    className: "form-switcher__input"
  }, inputProps)), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: "form-switcher__label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text_color-success text_weight-medium"
  }, children)));
};